import "./Rodape.css";

const Rodape = () => {
  return (
    <footer className="rodape__footer">
      <img src="/imagens/rodape.png" alt="rodape da organo" />
    </footer>
  );
};

export default Rodape;
